












































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import FileInputNormalizer from '@/classes/normalizers/field-normalizers/FileInputNormalizer';
import { FileData } from '@/types/asset';

const INPUT_LABELS = {
  LOADING: 'Загружается...',
  ATTACH: 'Прикрепить',
};

@Component
export default class FileField extends Vue {
  fileData: FileData|null = null;

  loading = false;

  normalizer = new FileInputNormalizer();

  @Prop()
  value!: number;

  @Prop()
  label!: string;

  get inputLabel(): string {
    return this.loading
      ? INPUT_LABELS.LOADING
      : INPUT_LABELS.ATTACH;
  }

  get fieldAttrs() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id, label, ...attrs } = this.$attrs;
    return attrs;
  }

  /* TODO preview не медиа файлов */
  get isUploadedFileImage() {
    return this.fileData?.mimetype?.includes('image');
  }

  @Watch('value', { immediate: true })
  async onValueChange(value: Record<string, number>) {
    if (value) {
      this.fileData = await this.normalizer.normalize(value.id);
    }
  }

  async onChange(file: File): Promise<void> {
    if (file) {
      this.loading = true;
      try {
        const id = await this.normalizer.reverseNormalize(file);
        if (id) {
          this.$emit('input', { id });
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    } else {
      this.resetFile();
    }
  }

  resetFile(): void {
    this.$emit('input', { id: null });
  }
}
